export const QSAInfosContentProfiles = ['internalRevenueService', 'serasaExperian'];

export const QSAInfosContentExecutions = [
  'internalRevenueService',
  'serasaExperian',
  'informedViaParameter',
];
